import {
  NumberFieldFormikField,
  TextInputFormikField,
  Toggle,
} from "@certn/cascadia-react";
import { Text } from "@certn/cascadia";
import { useField } from "formik";
import { useTranslation } from "react-i18next";

import { ADDRESS_BASED_TEMPLATE_DEFAULTS } from "./types";

interface AddressBasedTemplateFormFieldsProps {
  isDisabled?: boolean;
  showNameField?: boolean;
  defaultLookbackYears?: number;
}

export function AddressBasedTemplateFormFields({
  isDisabled = false,
  showNameField = true,
  defaultLookbackYears = ADDRESS_BASED_TEMPLATE_DEFAULTS.DEFAULT_LOOKBACK_YEARS,
}: AddressBasedTemplateFormFieldsProps) {
  const { t } = useTranslation();
  const [applyResidencyField, , applyResidencyHelpers] = useField<boolean>(
    "apply_residency_rules_to_current_address"
  );

  return (
    <>
      {showNameField && (
        <>
          <Text style="form/section-heading">{t("Template details")}</Text>
          <TextInputFormikField
            name="name"
            isRequired
            label={t("Template name")}
            testID="template-name"
            isDisabled={false}
          />
        </>
      )}

      <Text style="form/section-heading">{t("Residency Rules")}</Text>
      <Text style="input/helper" color="text-weak">
        {t(
          "Define how long an applicant must have lived in a country within a set time window to trigger a check. Example: '6 months in the past 5 years' means we'll only run it if the applicant lived in a country for at least 6 months consecutively, during that 5-year look back period."
        )}
      </Text>
      <NumberFieldFormikField
        name="minimum_duration_months"
        minValue={ADDRESS_BASED_TEMPLATE_DEFAULTS.MIN_DURATION_MONTHS}
        maxValue={ADDRESS_BASED_TEMPLATE_DEFAULTS.MAX_DURATION_MONTHS}
        defaultValue={ADDRESS_BASED_TEMPLATE_DEFAULTS.DEFAULT_DURATION_MONTHS}
        label={t("Minimum length of stay (months)")}
        testID="minimum-duration"
        isRequired
        description={t("Default is {{months}} months.", {
          months: ADDRESS_BASED_TEMPLATE_DEFAULTS.DEFAULT_DURATION_MONTHS,
        })}
        isDisabled={isDisabled}
      />
      <NumberFieldFormikField
        name="lookback_years"
        minValue={ADDRESS_BASED_TEMPLATE_DEFAULTS.MIN_LOOKBACK_YEARS}
        maxValue={ADDRESS_BASED_TEMPLATE_DEFAULTS.MAX_LOOKBACK_YEARS}
        defaultValue={defaultLookbackYears}
        label={t("Look back period (years)")}
        testID="lookback-period"
        isRequired
        isDisabled={isDisabled}
      />
      <Toggle
        isSelected={applyResidencyField.value}
        onChange={applyResidencyHelpers.setValue}
        testID="apply-residency-rules-to-current-address"
        isDisabled={isDisabled}
      >
        {t("Apply residency rules to current address")}
      </Toggle>
    </>
  );
}
